import api from "./api";

const playerService = {
  getPlayers: async () => {
    const response = await api.get("/shop/players");
    return response.data;
  },

  createPlayer: async (playerData) => {
    const response = await api.post("/shop/create-player", {
      full_name: String(playerData.full_name || "").trim(),
      username: String(playerData.username || "").trim(),
      password: String(playerData.password || ""),
      mobile: String(playerData.mobile || "").trim(),
    });

    return response.data;
  },

  transferToPlayer: async (playerId, amount) => {
    const response = await api.post(
      "/shop/transfer-to-player",
      {
        player_id: Number(playerId),
        amount: Number(amount),
      }
    );

    return response.data;
  },

  updatePlayerStatus: async (playerId, status) => {
    const nextStatus = String(status).toUpperCase();
    const payload = {
      player_id: Number(playerId),
      id: Number(playerId),
      status: nextStatus,
    };

    try {
      const response = await api.patch("/shop/player-status", payload);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404 || error.response?.status === 405) {
        const response = await api.post("/shop/player-status", payload);
        return response.data;
      }
      throw error;
    }
  },
};

export default playerService;